module.exports = __webpack_public_path__ + "img/logo.307ee4e0.svg";